import { useDigiohAPIReady } from '@/common/hooks/digioh/use-digioh-api-ready';
import { useDigiohAppStateModal } from '@/common/hooks/digioh/use-digioh-app-state-modal';
import { useDigiohMailboxCallbacks } from '@/common/hooks/digioh/use-digioh-mailbox-callbacks';

interface DigiohModalPageWrapperProps {
  pageSource: string;
}

/** This hook should be used on any page that we have Digioh active on that can show a modal from our
 *  codebase. We currently (as of Nov. 2024) only have Digioh active on homepage, catalog
 *  (not choose market), and the pdp. Of those pages, only inventory and pdp have the ability to show
 *  modals. */
export const useDigiohModalPageWrapper = ({
  pageSource,
}: DigiohModalPageWrapperProps) => {
  const ready = useDigiohAPIReady();
  useDigiohAppStateModal(ready);
  useDigiohMailboxCallbacks({ pageSource, ready });
};
